import { dispatchCustomEvent } from '../dispatch-custom-event';

export function eventNamespaceFactory(namespace: string) {
	return (element: EventTarget, eventName: string) =>
		dispatchCustomEvent(element, eventName + '.' + namespace);
}
